import React from 'react';

import { Dialog, Autocomplete } from '@shared/components';
import { getSortedList } from '@utils';

import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ClearIcon from '@assets/icons/cross-white.svg';
import useStyles from './style';

const defaultState = {
  selectedSites: [],
};

const FilterComponent = ({
  sites = [],
  isOpen = false,
  onClose = () => {},
  onSave = () => {},
}) => {
  const classes = useStyles();
  const [state, setState] = React.useState(defaultState);

  //HANDLERS
  const handleSave = () => {
    onSave(state.selectedSites);
    setState(defaultState);
  };

  const handleClose = () => {
    setState(defaultState);
    onClose();
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: option => option.label || '',
  });

  //JSX
  const isSaveDisabled = !state.selectedSites.length;
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      classes={{
        paper: classes.filter,
      }}
    >
      <Dialog.Title hasClose />
      <Dialog.Content>
        <Typography variant='h5' className='bold-font'>
          Filter Options
        </Typography>
        <Typography variant='body1' className='color-text-secondary mt-1'>
          Define filter criteria below.
        </Typography>
        <Typography variant='body1' className='bold-font mt-4'>
          Parameter
        </Typography>
        <Autocomplete
          fullWidth
          disableClearable
          getOptionLabel={option => {
            return option.label || '';
          }}
          value={state.selectedSites}
          options={getSortedList(sites)}
          filterOptions={filterOptions}
          onChange={(event, values) => {
            setState(prevState => ({
              ...prevState,
              selectedSites: values.slice(),
            }));
          }}
          placeholder='Sites'
          multiple
          classes={{
            tag: classes.siteChip,
          }}
          chipProps={{
            deleteIcon: <img src={ClearIcon} alt='add-filter' />,
            size: 'small',
          }}
        />
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          variant='outlined'
          className='bold-font mr-3 mb-4'
          onClick={handleClose}
        >
          <Typography variant='button' className='pl-4 pr-4'>
            Cancel
          </Typography>
        </Button>
        <Button
          disabled={isSaveDisabled}
          variant='contained'
          color='primary'
          className='bold-font mr-4 mb-4 pl-1 pr-1'
          onClick={handleSave}
        >
          <Typography variant='button' className='pl-8 pr-8'>
            Save
          </Typography>
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};
export default FilterComponent;
